import React from "react";

import { Icon, IconProps } from "../";

export const CheckOvalIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.08059 10.5481C7.7877 10.2552 7.31283 10.2552 7.01993 10.5481C6.72704 10.841 6.72704 11.3159 7.01993 11.6088L10.5555 15.1443C10.8484 15.4372 11.3232 15.4372 11.6161 15.1443L16.9801 9.78033C17.273 9.48744 17.273 9.01256 16.9801 8.71967C16.6872 8.42678 16.2123 8.42678 15.9194 8.71967L11.0858 13.5533L8.08059 10.5481Z"
      />
    </Icon>
  );
};
